import React from 'react';
import i18next from 'i18next';
import { DateFormatter } from 'components/AppTable/CellsComponents';

const formatOptional = value => (value === 0 || value ? value : '—');

const getTableConfig = () => [
  {
    title: i18next.t('tablesLabels.id'),
    field: 'id',
    columnWidth: '80px',
    isSorting: true,
  },
  {
    title: i18next.t('tablesLabels.type'),
    field: 'type',
    columnWidth: '200px',
    isSorting: true,
    Component: value =>
      i18next.t(`jobs.types.${value}`, {
        defaultValue: value,
      }),
  },
  {
    title: i18next.t('tablesLabels.status'),
    field: 'status',
    columnWidth: '120px',
    isSorting: true,
  },
  {
    title: i18next.t('jobs.context'),
    field: 'context',
    columnWidth: '260px',
    Component: formatOptional,
  },
  {
    title: i18next.t('tablesLabels.company'),
    field: 'companyName',
    columnWidth: '160px',
    Component: formatOptional,
  },
  {
    title: i18next.t('tablesLabels.trainingPart'),
    field: 'trainingPartName',
    columnWidth: '200px',
    Component: formatOptional,
  },
  {
    title: i18next.t('jobs.error'),
    field: 'errorMessage',
    columnWidth: '220px',
    Component: formatOptional,
  },
  {
    title: i18next.t('tablesLabels.date'),
    field: 'createdAt',
    columnWidth: '180px',
    isSorting: true,
    Component: value => <DateFormatter value={value} format="MM/DD/YYYY LT" />,
  },
  {
    title: i18next.t('jobs.startedAt'),
    field: 'startedAt',
    columnWidth: '180px',
    isSorting: true,
    Component: value => (value ? <DateFormatter value={value} format="MM/DD/YYYY LT" /> : '—'),
  },
  {
    title: i18next.t('jobs.finishedAt'),
    field: 'finishedAt',
    columnWidth: '180px',
    isSorting: true,
    Component: value => (value ? <DateFormatter value={value} format="MM/DD/YYYY LT" /> : '—'),
  },
];

export default getTableConfig;
